export const copyToClipboard = async (text: string) => {
  if (navigator?.clipboard) {
    await navigator.clipboard.writeText(text).catch((e) => console.warn('Copy failed', e));
  } else {
    const input = document.createElement('textarea');
    input.value = text;
    document.body.appendChild(input);
    input.select();
    document.execCommand('copy');
    document.body.removeChild(input);
  }
};
